import type { JSX } from 'react'
import type { ILabelProps } from 'atoms/Label'
import type { ILabelGroupProps } from '../LabelGroup'

import { LabelSecondaryRoundedSmallTemplate } from 'atoms/Label/Templates'
import { LabelGroup } from '../LabelGroup'

export interface ILabelGroupTemplate4Props extends Omit<
  ILabelGroupProps,
  'children'
> {
  list: ILabelProps['title'][]
}

export const LabelGroupTemplate4 = ({
  list = [],
  ...rest
}: ILabelGroupTemplate4Props): JSX.Element => (
  <LabelGroup {...rest}>
    {list?.length > 0 &&
      list.map((title, i) =>
        title ? (
          <LabelSecondaryRoundedSmallTemplate
            key={`${i}${title}`}
            title={title}
          />
        ) : null
      )}
  </LabelGroup>
)

LabelGroupTemplate4.displayName = 'LabelGroupTemplate4'
